import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import Uuid from '../../module/common/models/Uuid.ts'
import File from '../../module/common/models/File.ts'
import Invoice from '../../module/common/models/Invoice.ts';
import Basic_button from '../../components/basic_button.vue';
import Confirm_button from '../../components/confirm_button.vue';
import { Size } from '../../components/basic_button/size.ts'
import { store as data_store } from '../../store.ts'

interface Props {
    files: File[],
    selected_file_id: Uuid | null,
    selected_invoice_ids: Uuid[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'invoice_list',
  props: {
    files: { type: Array, required: true },
    selected_file_id: { type: [Object, null], required: true },
    selected_invoice_ids: { type: Array, required: true }
  },
  emits: [
    'select_additional_invoices',
    'clear_and_select_invoices',
    'merge_invoices',
    'delete_file',
    'exclude_invoice'
],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

// Define emits
const emit = __emit

const prop_files = computed(() => props.files)
const prop_selected_file_id = computed(() => props.selected_file_id)
const prop_selected_invoice_ids = computed(() => props.selected_invoice_ids)

const previously_selected_invoice_id = ref(new Uuid())

// Methods
function multiple_selected_in_file(file: File, selected_file_id: Uuid | null, selected_invoice_ids: Uuid[]) {
    if (selected_file_id === null) {
        return false
    } 
    return selected_invoice_ids.length > 1 && selected_file_id.get() === file.id.get()
}

function is_invoice_id_in_file(file: File, invoice_id: Uuid) {
    const index = file.invoices.findIndex((tmp_invoice) => tmp_invoice.id.get() === invoice_id.get())
    return index !== -1
}

function select_invoice(event: MouseEvent, file: File, invoice: Invoice, selected_invoice_ids: Uuid[]) {
    if (
        (event.ctrlKey || event.shiftKey) &&
        is_invoice_id_in_file(file, invoice.id) &&
        is_invoice_id_in_file(file, new Uuid(previously_selected_invoice_id.value.get()))
    ) {
        if (event.ctrlKey) {
            const index = selected_invoice_ids.findIndex(
                (tmp_selected_invoice_id) => tmp_selected_invoice_id.get() === invoice.id.get()
            )
            if (index === -1) {
                previously_selected_invoice_id.value = new Uuid(invoice.id.get())
                emit('select_additional_invoices', file, [invoice])
            }
        } else if (event.shiftKey) {
            let first_index = file.invoices.findIndex(
                (tmp_invoice) => tmp_invoice.id.get() === previously_selected_invoice_id.value.get()
            )
            let second_index = file.invoices.findIndex(
                (tmp_invoice) => tmp_invoice.id.get() === invoice.id.get()
            )

            if (first_index > second_index) {
                const tmp_index = first_index
                first_index = second_index
                second_index = tmp_index
            }

            const new_selected_invoices: Invoice[] = []
            for (let i = first_index; i <= second_index; i++) {
                new_selected_invoices.push(file.invoices[i])
            }
            emit('clear_and_select_invoices', file, new_selected_invoices)
        }
    } else {
        previously_selected_invoice_id.value = new Uuid(invoice.id.get())
        emit('clear_and_select_invoices', file, [invoice])
    }
}

function merge_invoices(file: File, selected_invoice_ids: Uuid[] ) {
    previously_selected_invoice_id.value = new Uuid()
    emit('merge_invoices', file, selected_invoice_ids)
}

function delete_file(file: File) {
    emit('delete_file', file)
}

function exclude_invoice(event: Event, file: File, invoice: Invoice) {
    const target = event.target as HTMLInputElement;
    const loc_is_checked = target.checked;
    emit('exclude_invoice', file, invoice, !loc_is_checked)
}

function display_currency(money: number | string | null) {
    function is_numeric(str: number | string): boolean {
        if (typeof str == "number") return true
        if (typeof str != "string") return false // we only process strings!  
        return !isNaN(str as unknown as number) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    if(typeof money == "undefined"
        || money === null
        || !is_numeric(money)
    ) {
        return ""
    }

    if (typeof money === "string") {
        money = parseFloat(money)
    }

    return money.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });
}

function li_styles(invoice: Invoice, arg_selected_invoice_ids: Uuid[]) {
    const loc_invoice_id_strings  = arg_selected_invoice_ids.map((tmp_invoice_id) => tmp_invoice_id.get())

    if (loc_invoice_id_strings.includes(invoice.id.get())) {
        return [
            'flex',
            'w-full',
            'items-center',
            'gap-3',
            'px-3',
            'py-2.5',
            'text-sm',
            'font-medium',
            'bg-brand-100',
            'text-brand-600',
            'dark:text-gray-400',
            'dark:hover:bg-brand-500/[0.12]',
            'dark:hover:text-brand-400'
        ]
    } else {
        return [
            'flex',
            'w-full',
            'items-center',
            'gap-3',
            'px-3',
            'py-2.5',
            'text-sm',
            'font-medium',
            'text-gray-500',
            'hover:bg-brand-50',
            'hover:text-brand-500',
            'dark:text-gray-400',
            'dark:hover:bg-brand-500/[0.12]',
            'dark:hover:text-brand-400'
        ]
    }
}


const __returned__ = { props, emit, prop_files, prop_selected_file_id, prop_selected_invoice_ids, previously_selected_invoice_id, multiple_selected_in_file, is_invoice_id_in_file, select_invoice, merge_invoices, delete_file, exclude_invoice, display_currency, li_styles, Basic_button, Confirm_button, get Size() { return Size } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})